export interface ProcessStep {
  number: number;
  title: string;
  description: string;
}

export const processSteps: ProcessStep[] = [
  {
    number: 1,
    title: "Consultation & Discovery",
    description: "We begin with a thorough consultation to understand your business, goals, and requirements. This discovery phase helps us identify key objectives, target audience, and technical needs to ensure our solution perfectly aligns with your vision."
  },
  {
    number: 2,
    title: "Design & Prototyping",
    description: "Our design team creates comprehensive wireframes and visual designs based on your brand and requirements. We focus on user experience, accessibility, and responsive design to ensure your website looks and functions beautifully across all devices."
  },
  {
    number: 3,
    title: "Development",
    description: "Our British full-stack developers build your website or application using modern, scalable technologies. We implement clean, efficient code with a focus on security, performance, and search engine optimization from the ground up."
  },
  {
    number: 4,
    title: "Testing & Quality Assurance",
    description: "We conduct rigorous testing across multiple devices, browsers, and scenarios to ensure everything works flawlessly. Our QA process includes performance testing, security checks, and accessibility compliance verification."
  },
  {
    number: 5,
    title: "Launch",
    description: "Once approved, we carefully deploy your website to your hosting environment, ensuring a smooth transition with minimal downtime. We handle all technical aspects of the launch, from DNS configuration to final checks."
  },
  {
    number: 6,
    title: "Ongoing Support & Maintenance",
    description: "Our relationship continues after launch with ongoing maintenance and support packages. We ensure your website remains secure, up-to-date, and performing optimally, with regular backups, updates, and performance monitoring."
  }
];